// extracted by mini-css-extract-plugin
module.exports = {"page":"login_page__1NAlm","form":"login_form__2M3Fd"};